export enum RouteNames {
  LOGIN_LAYOUT = "LoginLayout",
  LOGIN_VIEW = "LoginView",
  MAIN_LAYOUT = "MainLayout",
  SUPPORT_MAIN_PAGE = "SupportMainPage",
  ANALYTICS = "SupportAnalyticsPage",
  ACCESSES = "SupportAccessesPage",
  THEME = "SupportThemesPage",
  CURRENT_TICKET = "SupportTicket",
  NOT_FOUND = "NotFound",
}

export const RoutePaths: Record<RouteNames, string> = {
  [RouteNames.LOGIN_LAYOUT]: "/login",
  [RouteNames.LOGIN_VIEW]: "",
  [RouteNames.MAIN_LAYOUT]: "/",
  [RouteNames.SUPPORT_MAIN_PAGE]: "/support-main-page",
  [RouteNames.ACCESSES]: "/accesses",
  [RouteNames.ANALYTICS]: "/analytics",
  [RouteNames.THEME]: "/theme",
  [RouteNames.CURRENT_TICKET]: "/support-main-page/:id",
  [RouteNames.NOT_FOUND]: "/:pathMatch(.*)*",
};
